import {FC} from "react"
import {WidgetType} from "@dv5/domain"
import {DocumentIcon, TaskIcon} from "@dv5/components"

interface Props {
    type: WidgetType
}

interface TypeConfig {
    label: string
    icon: FC<{ className?: string }>
}

const typeConfig: Partial<Record<WidgetType, TypeConfig>> = {
    [WidgetType.DOCUMENT]: {label: 'Document', icon: DocumentIcon},
    [WidgetType.TASK]: {label: 'Task', icon: TaskIcon},
}

export const WidgetTypeBadge: FC<Props> = ({type}) => {
    const config = typeConfig[type]
    if (!config) {
        return null
    }
    const IconComponent = config.icon
    return (
        <div className='widget-type-badge' title={config.label}>
            <IconComponent className='widget-type-badge__icon'/>
        </div>
    )
}
